import script from "./ProfileEmployerContent.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileEmployerContent.vue?vue&type=script&setup=true&lang=js"

import "./ProfileEmployerContent.vue?vue&type=style&index=0&id=9ed08c1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9ed08c1c"]])

export default __exports__